import React from 'react';
import styled from 'styled-components';
import { useField, connect } from 'formik';
import { DayPicker, HourPicker } from 'datepicker-wrap';

import Error from '../components/Error';
import { FormLabel as Label } from '~ui-kit';
import FieldContextFeeder from '../components/FieldContextFeeder';

const DateField = props => {
  const [field, meta] = useField(props);
  const error = meta.touched && meta.error;
  const { setFieldValue } = props.formik;

  const name = props.id || props.name;

  const handleDayChange = date => {
    setFieldValue(name, date);
  };

  const handleTimeChange = date => {
    setFieldValue(name, date);
  };

  return (
    <Aligner row={props.row}>
      <Label
        htmlFor={props.id || props.name}
        required={props.required}
        info={props.info}
      >
        {props.label}
      </Label>
      <Container>
        <DayPicker selected={field.value} onChange={handleDayChange} />
        {props.withTime && (
          <HourPicker selected={field.value} onChange={handleTimeChange} />
        )}
      </Container>
      {error ? <Error>{meta.error}</Error> : null}
    </Aligner>
  );
};

const Aligner = styled.div`
  ${p =>
    p.row &&
    `
    display: flex;
    align-items: center;
    & > label {
      margin: 0 12px 0 0;
    }
  `}
  max-width: var(--field-width);
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  & > :nth-child(2) {
    margin-left: 16px;
  }
`;

export default FieldContextFeeder(connect(DateField));
